import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import FormControl from "@material-ui/core/FormControl";
import { Cancel } from "@material-ui/icons";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";
import LoadProfile from "components/services/LoadProfile";
import LoadGender from "components/services/LoadGender";

const useStyles = makeStyles(cardBodyStyle);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function NewUser(props) {
  const classes = useStyles();

  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");
  const [errorServer, setErrorServer] = useState(false);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    name: "",
    lastName: "",
    email: "",
    gender_id: "",
    gendername: "",
    genderdata: [],
    profile_id: "",
    profilename: "",
    profiledata: [],
    errorName: false,
    errorEmail: false,
    errorLastName: false,
    errorProfile: false,
    errorGender: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorName: false,
      errorEmail: false,
      errorLastName: false,
    });
    setOpenAlert(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const submitForm = (e) => {
    e.preventDefault();
    setOpenAlert(false);
    setErrorServer(false);

    if (values.name.length === 0) {
      setValues({ ...values, errorName: true });
      setMensaje('El campo "Nombre" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.lastName.length === 0) {
      setValues({ ...values, errorLastName: true });
      setMensaje('El campo "Apellido" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.gendername.length === 0) {
      setValues({ ...values, errorGender: true });
      setMensaje('El campo "Género" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.profilename.length === 0) {
      setValues({ ...values, errorProfile: true });
      setMensaje('El campo "Perfil" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else if (values.email.length === 0) {
      setValues({ ...values, errorEmail: true });
      setMensaje('El campo "Email" es obligatorio.');
      setOpenAlert(true);
      setError("error");
    } else {
      const dataValue = {
        email: values.email.toLowerCase().trim(),
        name: values.name,
        lastname: values.lastName,
        profile_id: values.profile_id,
        gender_id: values.gender_id,
        keyAplication: keyAplication,
      };

      axios
        .post(`${urlServices}routes_usersinsert.php`, dataValue, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.data.code === 1) {
            setMensaje("Registro con éxito.");
            setOpenAlert(true);
            setError("success");

            setValues({
              ...values,
              name: "",
              lastName: "",
              profile_id: "",
              profiledata: [],
              gender_id: "",
              genderdata: [],
              email: "",
            });

            props.callBackRefresh();
          }
        })
        .catch((e) => {
          setMensaje("Error de conexión, intente más tarde.");
          setOpenAlert(true);
          setError("error");
          setErrorServer(true);
        });
    }
  };

  const changeProfile = (data) => {
    setValues({
      ...values,
      profile_id: data !== null ? data.id : "",
      profilename: data !== null ? data.name : "",
      profiledata: data !== null ? data : [],
      errorProfile: false,
    });
  };

  const changeGender = (data) => {
    setValues({
      ...values,
      gender_id: data !== null ? data.id : "",
      gendername: data !== null ? data.name : "",
      genderdata: data !== null ? data : [],
      errorGender: false,
    });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        //onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        style={{ zIndex: 100 }}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    <div className={classes.titleCardFilter}>Nuevo usuario</div>
                    <div className={classes.lineBottom}></div>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="name"
                        value={values.name}
                        error={values.errorName}
                        onChange={handleChange("name")}
                        fullWidth
                        required
                        label="Nombres"
                        margin="dense"
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="lastName"
                        value={values.lastName}
                        error={values.errorLastName}
                        onChange={handleChange("lastName")}
                        fullWidth
                        required
                        label="Apellidos"
                        margin="dense"
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadGender
                      refresh={changeGender}
                      value={values.genderdata}
                      error={values.errorGender}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LoadProfile
                      refresh={changeProfile}
                      value={values.profiledata}
                      error={values.errorProfile}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      autoComplete="off"
                      name="email"
                      value={values.email}
                      onChange={handleChange("email")}
                      label="E-mail"
                      error={values.errorEmail}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <div className={classes.titleCardFilter}>
                      {" "}
                      <small>
                        Al registrar esta cuenta, se creará automáticamente la
                        contraseña al usuario. <b>(CONTRASEÑA: 12345)</b>
                      </small>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    {errorServer ? (
                      <Alert severity="error">
                        Error en la consulta al servidor
                      </Alert>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <br></br>
                    <center>
                      <Button
                        type="submit"
                        className={classes.buttonSubmit}
                        onClick={submitForm}
                      >
                        Guardar
                      </Button>
                    </center>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Snackbar
              open={openAlert}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              onClose={handleClose}
            >
              <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
                <Alert
                  onClose={handleClose}
                  severity={error === "error" ? "error" : "success"}
                  elevation={6}
                  variant="filled"
                >
                  {mensaje}
                </Alert>
              </Slide>
            </Snackbar>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
